<template>
    <v-container class="grey lighten-5">
        <v-row
            no-gutters
            justify="center"
        >
            <v-col
                cols="4"
                md="5"
            >
                <font-awesome-icon
                class="index__description__icon"
                :icon="['fas', 'dove']">
                </font-awesome-icon>
            </v-col>
            <v-col
                cols="4"
                sm="5"
            >
                <font-awesome-icon
                class="index__description__icon"
                :icon="['fab', 'twitter']">
                </font-awesome-icon>
            </v-col>
        <v-row justify="center">
            <v-col md="10">
                <h2>最近遊んでくれたランキング</h2>
            </v-col>
        </v-row>
        </v-row>
        <v-row justify="center">
            <v-col md="10">
                <h3>
                <v-list rounded>
                <v-list-item
                    class="pa-3"
                    outlined
                    tile
                    v-for="(recentPost, index) in recentPosts"
                    :key="recentPost.id"
                >
                <v-list-item-title>
                <router-link
                    class="ranking__title"
                    v-bind:to="{name: 'UserPage',
                    params: {screen_name: recentPost}}">
                {{index + 1}} 位 
                {{recentPost}}
                </router-link>
                </v-list-item-title>
                </v-list-item>
                </v-list>
                </h3>
            </v-col>
        </v-row>
        <v-row
            no-gutters
            justify="center"
        >
            <v-col
                cols="4"
                md="5"
            >
                <font-awesome-icon
                class="index__description__icon"
                :icon="['fas', 'ghost']">
                </font-awesome-icon>
            </v-col>
            <v-col
                cols="4"
                sm="5"
            >
                <font-awesome-icon
                class="index__description__icon"
                :icon="['fas', 'chart-bar']">
                </font-awesome-icon>
            </v-col>
            </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'Ranking',
  components: {
  },
//   data () {
//       return {
//           recentPosts: null,
//           recentUsers: null
//       }
//   },
mounted () {
    this.init()
    this.start()
  },
destroyed () {
    this.stop()
  },
  methods: {
    init () {
      this.$store.dispatch('user_count/clear')
    },
    start () {
    //   this.$store.dispatch('user_count/countUser')
      this.$store.dispatch('user_count/recentUser')
      this.$store.dispatch('user_count/recentPost')
    },
    stop () {
      this.$store.dispatch('user_count/stopListener')
    }
  },
    computed: {
        recentPosts() {
            // this.$store.getters['user_count/recentPost']
            // console.log(this.$store.getters['user_count/recentPost'])
            // console.log(new Set(this.$store.getters['user_count/recentPost']))
            // const setRecentPosts = [new Set(this.$store.getters['user_count/recentPost'])]
            // console.log(setRecentPosts)

            return new Set(this.$store.getters['user_count/recentPost'])
        },
        recentUsers() {
            // console.log(this.$store.getters['user_count/recentUser'])
            return this.$store.getters['user_count/recentUser']
        }
    }
}
</script>

<style scoped>
.index__description__icon {
    width: 40px;
    height: 40px;
}

.ranking__title {
  color:#546E7A !important;
  /* text-decoration: inherit; */
}
</style>



// WEBPACK FOOTER //
// src/components/common/PlayRanking.vue